import React from "react";
import Header from "./Header/Header";
import { Profile } from "./Profile/Profile";
import { Footer } from "./Footer/Footer";
import "../Home/Footer/Footer.css";

export const Home = () => {
  return (
    <div className="hContainer">
      <Header />
      <Profile />
      <Footer />
    </div>
  );
};
